import { render, staticRenderFns } from "./detail_layout.vue.js?vue&type=template&id=1119fdb4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./detail_layout.vue?vue&type=template&id=1119fdb4&vue3"
import script from "./detail_layout.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./detail_layout.vue?vue&type=script&lang=js&vue3"
export * from "./detail_layout.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./detail_layout.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports